module.exports = __webpack_public_path__ + "img/role3.4f8714cf.png";